import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=535d977e&scoped=true&"
import script from "./CreateTask.vue?vue&type=script&lang=ts&"
export * from "./CreateTask.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=535d977e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d977e",
  null
  
)

export default component.exports